"use client";

import styles from "./Form.module.scss";
import { useState } from "react";
import sendDiningForm from "../../../lib/sendDiningForm";
import useDiningForm from "../../../hooks/useDiningForm";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { SecoundaryButton } from "../Buttons/Buttons";

export default function DiningPageForm() {
    const [selectDate, setSelectDate] = useState(new Date());
    const [selectedOption, setSelectedOption] = useState('');
    const [formMessage, setFormMessage] = useState('');
    const { values, handleChange } = useDiningForm();

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const datenmonth = new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
    });

    const handleDateChange = (date) => {
        setSelectDate(date);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormMessage({ state: 'loading' })
        setTimeout(() => {
            setFormMessage({ state: 'success' }),
                values.fullname = "",
                values.email = "",
                values.phoneno = "",
                values.message = "",
                setSelectedOption("")
            setSelectDate(new Date())
        }, 4000)
        try {
            const req = await sendDiningForm(values.fullname, values.email, values.phoneno, values.message, selectedOption, selectDate);
            if (req.status === 250) {
                setResponseMessage({ isSuccessful: true, message: 'Thank you for your message.' });
                alert("Thank you for your message.")
            }

        } catch (e) {
            console.log(e);
            setFormMessage({ state: 'error' })
        }
    };

    return (
        <>
            <section className={`${styles.form}`}>
                <div className="row">
                    <div className="col-md-8 offset-md-2 col-sm-12 contact_form">
                        <form className="row" onSubmit={handleSubmit}>
                            <div className={`${styles.form_group} col-md-6 col-sm-12`}>
                                <input
                                    id="fullname"
                                    type="text"
                                    name="fullname"
                                    onChange={handleChange}
                                    value={values.fullname}
                                    className="form-control"
                                    placeholder="Full Name"
                                    required
                                />
                            </div>
                            <div className={`${styles.form_group} col-md-6 col-sm-12`}>
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    onChange={handleChange}
                                    value={values.email}
                                    className="form-control"
                                    placeholder="Your Email"
                                    required
                                />
                            </div>
                            <div className={`${styles.form_group} col-md-6`}>
                                <input
                                    id="phoneno"
                                    required
                                    name="phoneno"
                                    type="number"
                                    onChange={handleChange}
                                    value={values.phoneno}
                                    className="form-control"
                                    placeholder="Phone Number"
                                />
                            </div>
                            <div className={`${styles.form_group} col-md-6`}>
                                <DatePicker wrapperClassName="diningform-date-picker"
                                    minDate={new Date()}
                                    className={styles.form_control}
                                    selected={selectDate}
                                    onChange={handleDateChange}
                                    placeholderText={'Please select a date'}
                                />
                            </div>
                            <div className={`${styles.form_group} col-md-12`}>
                                <div className="dining-radio-input">
                                    <span className="me-2"><strong>Booking For:</strong></span>
                                    <label>
                                        <input
                                            type="radio"
                                            value="Restaurant"
                                            checked={selectedOption === 'Restaurant'}
                                            onChange={handleOptionChange}
                                        />
                                        Restaurant
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            value="Bar"
                                            checked={selectedOption === 'Bar'}
                                            onChange={handleOptionChange}
                                        />
                                        Bar
                                    </label>
                                </div>
                            </div>
                            <div className={`${styles.form_group} col-md-12`}>
                                <textarea
                                    id="message"
                                    name="message"
                                    onChange={handleChange}
                                    value={values.message}
                                    className="form-control"
                                    placeholder="Message"
                                    required
                                ></textarea>
                            </div>
                            {/* <button type="submit" className="secoundary_btn">SEND REQUEST</button> */}

                            <div className="col-md-12 text-center">
                                <SecoundaryButton type="submit" buttonText={'SEND REQUEST'} />
                            </div>

                            {formMessage.state === 'loading' ? (
                                <div>Sending....</div>
                            ) : formMessage.state === 'error' ? (
                                <div className="form_message error">Something went wrong! Try again later.</div>
                            ) : (
                                formMessage.state === 'success' && <div className="success">Thankyou! Your Message has been delivered.</div>
                            )}
                        </form>
                    </div>
                </div>
            </section>
        </>
    )
}
